
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Grid, MenuItem, TextField } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query";
import { useGranjasQuery } from "../../../../hooks";
import { startSavingGalpones } from "../../../../services";

import Swal from "sweetalert2";



export const FormCreateUpdateGalpon = ({ initialState }) => {


    const { id } = useParams();
    const { granjasListQuery } = useGranjasQuery()
    const queryClient = useQueryClient();



    const [formGalpon, setFormGalpon] = useState(initialState);
    const { nombre, cantidad, genero, granja, alto, largo, ancho, } = formGalpon;
    const  handleInputChange = ({ target }) => {
        setFormGalpon({
            ...formGalpon,
            [target.name]: target.value
        });
    }


    
    
    const crearActInformacion = async(e) => {
        e.preventDefault();
        if([nombre, cantidad, genero, granja, alto, largo, ancho].includes('') ){
            return Swal.fire('Error', 'Formulario Incorrecto por favor llene todos los campos', 'error');
        }
        const result = await Swal.fire({
            title: `${(id) ? 'Actualizar' : 'Crear'} Galpon`,
            text: `¿Esta seguro de ${(id) ? 'Actualizar' : 'Crear'} Galpon?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si ${(id) ? 'Actualizar' : 'Crear'}`,
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        const resp = await startSavingGalpones({...formGalpon, id});
        if(resp){
            if(!id) { 
                setFormGalpon( initialState ); 
            }else {
                queryClient.invalidateQueries({ queryKey: ['galpon-id', id] });
            }
            queryClient.invalidateQueries({queryKey: ['galpones-list']});
        }
    }





    return (

        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={ 2 }>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Nombre Galpon'
                        type='text'
                        placeholder='Nombre Galpon'
                        fullWidth
                        name='nombre'
                        value={ nombre }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Cantidad'
                        type='number'
                        placeholder='Cantidad'
                        fullWidth
                        name='cantidad'
                        value={ cantidad }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        select
                        label="Seleccione Granja"
                        fullWidth
                        name="granja"
                        value={granja}
                        onChange={handleInputChange}
                    >
                        <MenuItem value="">Seleccione Granja</MenuItem>
                        {Array.isArray(granjasListQuery?.data) && granjasListQuery.data.length > 0 ? (
                            granjasListQuery.data.map((g) => (
                                <MenuItem key={g.id} value={g.id}>
                                    {g.nombre}
                                </MenuItem>
                            ))
                        ) : (
                            <MenuItem disabled>No hay granjas disponibles</MenuItem>
                        )}
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        select
                        label="Seleccione Genero"
                        fullWidth
                        name='genero'
                        value={ genero }
                        onChange={ handleInputChange }
                    >
                        <MenuItem value=''>Seleccione Genero</MenuItem>
                        <MenuItem value='Hembra'>Hembra</MenuItem>
                        <MenuItem value='Macho'>Macho</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Alto'
                        type='number'
                        placeholder='Alto'
                        fullWidth
                        name='alto'
                        value={ alto }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Largo'
                        type='number'
                        placeholder='Largo'
                        fullWidth
                        name='largo'
                        value={ largo }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Ancho'
                        type='number'
                        placeholder='Ancho'
                        fullWidth
                        name='ancho'
                        value={ ancho }
                        onChange={ handleInputChange }
                    />
                </Grid>
            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={ 12 } sm={ 8 } >
                    <Button variant='contained' fullWidth type='submit'>
                        {`${id ? 'Actualizar' : 'Crear'} Galpon`}
                    </Button>
                </Grid>
            </Grid>
        </form>

    )
}
